export default [
    {
        value: {
            value: 'expired',
            id: 10
        },
        label: 'Vencida',
    }, {
        value: {
            value: 'inactive_renewal',
            id: 5
        },
        label: 'Renovada',
    }, {
        value: {
            value: 'normal',
            id: 1
        },
        label: 'Normal',
    }, {
        value: {
            value: 'inactive',
            id: 2
        },
        label: 'Baja',
    }, {
        value: {
            value: 'blocked_temporal',
            id: 6
        },
        label: 'Bloqueada',
    }, {
        value: {
            value: 'not_enabled',
            id: 7
        },
        label: 'Inhabilitada',
    }, {
        value: {
            value: 'report_associate',
            id: 4
        },
        label: 'Denunciada',
    }, {
        value: {
            value: 'inactive_reprint',
            id: 3
        },
        label: 'Reimpresión',
    }, {
        value: {
            value: 'report_IVR',
            id: 8
        },
        label: 'Denunciada IVR',
    }, {
        value: {
            value: 'blocked_IVR',
            id: 9
        },
        label: 'Bloqueada IVR',
    }
];
